import { render, staticRenderFns } from "./valmistumispyynnon-hyvaksynta.vue?vue&type=template&id=b67ed050&scoped=true&"
import script from "./valmistumispyynnon-hyvaksynta.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-hyvaksynta.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-hyvaksynta.vue?vue&type=style&index=0&id=b67ed050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67ed050",
  null
  
)

export default component.exports